import AsyncStorage from '@react-native-async-storage/async-storage';

export async function getAuthConfig() {
  const [access_token, url] = await Promise.all([
    AsyncStorage.getItem('access_token'),
    AsyncStorage.getItem('url')
  ]);
  return {url, headers: {Authorization: `Bearer ${access_token}`}};
}
